exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-dagen-kiezen .days-select{margin:30px 0}.result-box{margin-top:30px;padding-top:15px;border-top:1px solid}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05de1008","scoped":false,"hasInlineConfig":false}!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/page-dagen-kiezen.vue
// module id = 50
// module chunks = 0